<div class="flex flex-col items-center justify-center">
  <div class="flex items-center justify-center public-container">
    @if (registrationNotification) {
      <pin-notification type="alert" class="w-full">
        @switch (registrationNotification) {
          @case (registrationNotificationValues.username_already_exists) {
            Username is already taken. Please try again with a different username.
          }
          @case (registrationNotificationValues.data_validation_error) {
            The Account ID is not correct.
          }
          @case (registrationNotificationValues.try_again_later) {
            This page is currently unavailable. Please try again later.
          }
        }
      </pin-notification>
    }
  </div>

  <div class="flex flex-col justify-center public-container">
    <div class="flex flex-row items-center justify-center registration-form">
      <form id="registrationForm" class="flex flex-col gap-3" [formGroup]="agentRegistrationForm" (ngSubmit)="sendRegistration()">
        <div class="flex flex-col gap-6">
          <div class="flex flex-col gap-4">
            <div class="dcp-h1" id="user.verification.title">
              Verify Account Association
            </div>

            <p id="tan.validation.subtitle" class="dcp-body">
              To help protect you, we need to verify your account association.
            </p>

            <div id="tan.validation" class="flex flex-row gap-2 items-center justify-between">
              <mat-form-field class="w-full" appearance="outline" id="user.transactionAccountNumber">
                <mat-label>Account ID</mat-label>

                <input matInput
                       placeholder="Account ID is required"
                       formControlName="accountIdentifier"
                       type="text"
                       maxlength="80"
                       autocomplete="off">
                @if (agentRegistrationForm.controls['accountIdentifier'].hasError('required')) {
                  <mat-error id="transaction.account.no.required">
                    Account ID is required
                  </mat-error>
                }
              </mat-form-field>

              <div class="flex">
                <pin-tooltip [isNewTooltip]="true"
                             tooltipId="transactionAccountTooltip"
                             aria-hidden="true"
                             ariaLabelValue="Additional Information Regarding Transaction Account Number."
                             iconClass="flex items-center"
                             tooltipContainerClass="registration-new-tooltip"
                             tooltipInfo="Please use any of your ICS or CDARS account IDs. For assistance locating an ID, please contact your institution.">
                </pin-tooltip>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-4">
            <div class="dcp-h1" id="create-account-title">
              Create Your Depositor Control Panel Account
            </div>

            <p class="dcp-body" id="user.verification.subtitle">
              To access the accounts associated to you, you must first create a Depositor Control Panel account.
            </p>

            <div id="user.verification">
              <div class="flex flex-col items-center justify-center">
                <mat-form-field class="w-full" appearance="outline" id="user.firstName">
                  <mat-label>First Name</mat-label>

                  <input matInput placeholder="First Name" formControlName="firstName" type="text" pinTrimField
                         maxlength="50" i18n-placeholder="@@firstName-placeholder">

                  @if (agentRegistrationForm.controls['firstName'].hasError('required')) {
                    <mat-error id="firstName.required" i18n="@@registration.username.firstName">
                      First Name is required
                    </mat-error>
                  }
                  @if (agentRegistrationForm.controls['firstName'].hasError('nonAsciiPrintable')) {
                    <mat-error>This field cannot contain invalid characters.</mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="w-full" appearance="outline" id="user.lastName">
                  <mat-label>Last Name</mat-label>

                  <input matInput placeholder="Last Name" formControlName="lastName" type="text" pinTrimField
                         maxlength="50" i18n-placeholder="@@lastName-placeholder">

                  @if (agentRegistrationForm.controls['lastName'].hasError('required')) {
                    <mat-error id="lastName.required" i18n="@@registration.username.lastName">
                      Last Name is required
                    </mat-error>
                  }
                  @if (agentRegistrationForm.controls['lastName'].hasError('nonAsciiPrintable')) {
                    <mat-error>This field cannot contain invalid characters.</mat-error>
                  }
                </mat-form-field>
              </div>

              <mat-form-field class="w-full" appearance="outline" id="user.credentials.username">
                <mat-label>Username</mat-label>

                <input matInput placeholder="Username" formControlName="username" type="text"
                       maxlength="50" i18n-placeholder="@@username-placeholder">

                @if (agentRegistrationForm.controls['username'].hasError('required')) {
                  <mat-error id="username.required" i18n="@@registration.username.required">
                    Username is required
                  </mat-error>
                }

                @if (agentRegistrationForm.controls['username'].hasError('nonAsciiPrintable')) {
                  <mat-error>This field cannot contain invalid characters.</mat-error>
                }
              </mat-form-field>

              <mat-form-field class="w-full" appearance="outline" id="user.credentials.password">
                <mat-label>Password</mat-label>

                <pin-password-input formControlName="password" (passwordFocus)="passwordTooltip.onPasswordFocus($event)"
                                    (passwordBlur)="onPasswordBlur()" [allowPaste]="false"></pin-password-input>

                @if (agentRegistrationForm.controls['password'].hasError('required')) {
                  <mat-error id="password.required" i18n="@@password.required">
                    Password is required
                  </mat-error>
                }

                @if (agentRegistrationForm.controls['password'].hasError('pattern')) {
                  <mat-error>Password does not meet the requirements</mat-error>
                }

              </mat-form-field>

              <pin-password-info [positionLeft]='passwordTooltip.passwordTooltipLeft'
                                 [positionTop]='passwordTooltip.passwordTooltipTop'
                                 [show]='passwordTooltip.showPasswordTooltip'
                                 (mouseenter)="passwordTooltip.isPasswordTooltipFocused=true"
                                 (mouseleave)="passwordTooltip.isPasswordTooltipFocused=false"
                                 customClass="registration-password-helper">
              </pin-password-info>

              <mat-form-field class="w-full" appearance="outline" id="user.credentials.verify.password">
                <mat-label>Verify Password</mat-label>

                <pin-password-input formControlName="passwordConfirmation" [allowPaste]="false"></pin-password-input>

                @if (agentRegistrationForm.controls['passwordConfirmation'].hasError('required')) {
                  <mat-error id="verify.password.invalid" i18n="@@verify.password.invalid">
                    You must verify your password
                  </mat-error>
                }

                @if (agentRegistrationForm.controls['passwordConfirmation'].hasError('pwdDoesNotMatch')) {
                  <mat-error id="verify.password.match" i18n="@@verify.password.match">
                    Verify Password does not match the Password entered
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <pin-button buttonStyle="filled" buttonId="create-account-button" [isDisabled]="loading">CREATE ACCOUNT</pin-button>

          <div class="flex flex-row items-center justify-center gap-2">
            <div data-testid="registration-already-have-account">Already have an account?</div>
             <pin-button buttonStyle="link" customClass="pb-1!" buttonId="registration-login-link" redirectUrl="/login">Log In</pin-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

@if (loading) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
